export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    type: 'checkbox',
    visible: !that.disabled,
  },
  {
    type: 'expand',
    width: 70,
    align: 'center',
    title: that.$l('INDEX.form_label_expand') || '展开',
    slots: {
      content: 'expandContent',
    },
  },
  {
    title: that.$l('inspection_doc_label_fileName') || '文档名称',
    field: 'fileName',
    minWidth: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('inspection_doc_label_fileType') || '文件类型',
    field: 'v_fileType',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_title_is_common') || '是否通用文档',
    field: 'v_isCommon',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('inspection_doc_label_uploadByName') || '上传人姓名',
    field: 'uploadByName',
    width: 120,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('inspection_doc_label_uploadTime') || '上传时间',
    field: 'uploadTime',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
